import { render, staticRenderFns } from "./104.vue?vue&type=template&id=deca08c0&scoped=true&"
var script = {}
import style0 from "./104.vue?vue&type=style&index=0&id=deca08c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deca08c0",
  null
  
)

export default component.exports